module.exports = __webpack_public_path__ + "static/media/calendar.73966a86.svg";